<div class="flx-modal" role="dialog" aria-modal="true">
    <div class="flx-modal__header">
        <div class="with-desc">
            <h2>Manage Working Hours</h2>
            <span class="sub">Set the working hours for this user</span>
        </div>
        <button class="icon-btn" aria-label="Close" [pTooltip]="translate?.general.buttons.close.singular"
            (click)="modalRef.hide()">
            <i class="fa-regular fa-xmark"></i>
        </button>
    </div>
    <div class="flx-modal__body">
        <div class="custella-content-row-two m-0" *ngFor="let day of workingDays">
            <div class="custella-content-row align-items-center my-2">
                <div class="w-150">
                    <div class="d-flex position-relative">
                        <div *ngIf="editForm" class="p-field-checkbox">
                            <p-checkbox [binary]="true" [ngModelOptions]="{standalone: true}"
                                (onChange)="selectWorkingDays(day.key, company.calendar[day.key])"
                                [(ngModel)]="company.calendar[day.key]" [id]="'check_SetWork' + day.key"></p-checkbox>
                        </div>
                        <span class="text-12 ms-3" [id]="'label_SetWork' + day.key">{{
                            translate?.setup.general.workingHours.fields[day.labelKey].singular }}</span>
                    </div>
                </div>

                <!-- VIEW MODE -->
                <span *ngIf="!editForm && company.calendar[day.key] && !company.calendar[day.key + 'AllDay']"
                    class="text-12 ms-3 w-150" [id]="'label_SetWork' + day.key + 'DateTime'">
                    {{ company.calendar[day.key + 'Start'] | momentDate : ' hh:mm a' : timezone }} - {{
                    company.calendar[day.key + 'End'] | momentDate : ' hh:mm a' : timezone }}
                </span>
                <span *ngIf="!editForm && company.calendar[day.key] && company.calendar[day.key + 'AllDay']"
                    class="text-12 ms-3 w-200" [id]="'label_SetWork' + day.key + 'AllDay'">
                    {{ translate?.setup.general.workingHours.fields.allDay.singular }}
                </span>
                <!-- unchecked day in view mode: blank row, nothing rendered -->

                <!-- EDIT MODE -->
                <div class="w-150" *ngIf="editForm">
                    <p-calendar [disabled]="!company.calendar[day.key] || company.calendar[day.key + 'AllDay']"
                        [(ngModel)]="company.calendar[day.key + 'Start']" [ngModelOptions]="{standalone: true}"
                        pattern="hh:mm a" [stepMinute]="15" hourFormat="12" [timeOnly]="true" inputId="timeonly"
                        appendTo="body" [id]="'picklist_SetWork' + day.key + 'StartField'"></p-calendar>
                </div>
                <div class="px-2" *ngIf="editForm"> - </div>
                <div class="w-150" *ngIf="editForm">
                    <p-calendar [disabled]="!company.calendar[day.key] || company.calendar[day.key + 'AllDay']"
                        [(ngModel)]="company.calendar[day.key + 'End']" [ngModelOptions]="{standalone: true}"
                        pattern="hh:mm a" [stepMinute]="15" hourFormat="12" [timeOnly]="true" appendTo="body"
                        [id]="'picklist_SetWork' + day.key + 'EndField'"></p-calendar>
                </div>

                <div class="w-130" *ngIf="editForm">
                    <div class="d-flex position-relative justify-content-center">
                        <div class="p-field-checkbox">
                            <p-checkbox [binary]="true" [disabled]="!company.calendar[day.key]"
                                (onChange)="nullify(day.key, company.calendar[day.key + 'AllDay'])"
                                [(ngModel)]="company.calendar[day.key + 'AllDay']" [ngModelOptions]="{standalone: true}"
                                [id]="'check_SetWork' + day.key + 'AllDay'"></p-checkbox>
                        </div>
                        <span class="text-12 ms-3" [id]="'label_SetWork' + day.key + 'AllDay2'">{{
                            translate?.setup.general.workingHours.fields.allDay.singular }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="flx-modal__footer">
        <button class="custella-btn-white" (click)="modalRef.hide()">Cancel</button>
        <p-button
            type="button"
            [label]="translate?.general.buttons.save.singular"
            styleClass="h-32"
            [disabled]="saving"
            (onClick)="onSave()"></p-button>
    </div>

</div>